 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"bundles/project.js": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "../static-" + (["1.58182","1.58181","1.58142","1.58187","1.58158","1.58204","1.56383","1.58190","1.57174","1.56482","1.57608","1.58193","1.58106","1.57625","1.58039","1.58202","1.57982","1.58107","1.58184","1.58197","1.58179","1.58186","1.58167","1.58196","1.58194","1.57199","1.43278","1.58044","1.56472","1.56134"][{"0":0,"1":1,"2":2,"3":0,"4":2,"5":0,"6":0,"7":3,"8":0,"9":4,"10":0,"11":5,"12":4,"13":0,"14":4,"15":6,"16":2,"17":4,"18":3,"19":7,"20":8,"21":0,"22":2,"23":6,"24":2,"25":6,"26":6,"27":8,"28":9,"29":10,"30":11,"31":12,"32":7,"33":4,"34":0,"35":4,"36":0,"37":0,"38":4,"39":0,"40":4,"41":2,"42":13,"43":13,"44":13,"45":2,"46":14,"47":4,"48":4,"49":4,"50":4,"51":4,"52":0,"53":4,"54":13,"55":13,"56":13,"57":15,"58":15,"59":13,"60":13,"61":4,"62":4,"63":2,"64":13,"65":2,"66":13,"67":4,"68":13,"69":13,"70":13,"71":13,"72":13,"73":13,"74":13,"75":13,"76":13,"77":13,"78":13,"79":13,"80":13,"81":13,"82":13,"83":13,"84":16,"85":13,"86":13,"87":13,"88":13,"89":13,"90":13,"91":13,"92":13,"93":13,"94":13,"95":13,"96":13,"97":13,"98":12,"99":13,"100":13,"101":13,"102":13,"103":13,"104":13,"105":13,"106":17,"107":17,"108":17,"109":17,"110":17,"111":17,"112":17,"113":17,"114":17,"115":17,"116":17,"117":17,"118":17,"119":17,"120":17,"121":17,"122":17,"123":17,"124":17,"125":11,"126":15,"127":11,"128":18,"129":18,"130":18,"131":18,"132":18,"133":18,"134":18,"135":18,"136":18,"137":18,"138":18,"139":18,"140":18,"141":18,"142":18,"143":18,"ad-editing":4,"onboarding-tour":15,"AdsUI-lang-da":18,"AdsUI-lang-de":19,"AdsUI-lang-es":20,"AdsUI-lang-fi":18,"AdsUI-lang-fr":18,"AdsUI-lang-it":21,"AdsUI-lang-ja":21,"AdsUI-lang-laboratory-copy-experiments-da":2,"AdsUI-lang-laboratory-copy-experiments-de":2,"AdsUI-lang-laboratory-copy-experiments-es":2,"AdsUI-lang-laboratory-copy-experiments-fi":2,"AdsUI-lang-laboratory-copy-experiments-fr":2,"AdsUI-lang-laboratory-copy-experiments-it":2,"AdsUI-lang-laboratory-copy-experiments-ja":2,"AdsUI-lang-laboratory-copy-experiments-nl":2,"AdsUI-lang-laboratory-copy-experiments-no":2,"AdsUI-lang-laboratory-copy-experiments-pl":2,"AdsUI-lang-laboratory-copy-experiments-pt-br":2,"AdsUI-lang-laboratory-copy-experiments-sv":2,"AdsUI-lang-laboratory-copy-experiments-zh-tw":2,"AdsUI-lang-nl":21,"AdsUI-lang-no":20,"AdsUI-lang-pl":15,"AdsUI-lang-pt-br":20,"AdsUI-lang-sv":22,"AdsUI-lang-zh-tw":22,"campaign-edit-panel":23,"collaboration-sidebar-drop-area":24,"collaboration-sidebar~message-handlers":25,"message-handlers":25,"task-edit-panel-modal":26,"reporting-actions-loader":27,"reporting-data__custom~reporting-data__main":28,"reporting-data__custom":28,"reporting-data__inboundDb~reporting-data__main~reporting-data__unified":7,"reporting-data__inboundDb~reporting-data__main":2,"reporting-data__main":2,"reporting-data__inboundDb":28,"reporting-data__unified":29,"campaign-edit-panel-body":23,"object-builder-client":1,"onboarding-tour-popover":8}[chunkId]] || "1.58205") + "/" + chunkId + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	var dlbs = [{"name":"head-dlb/bundle.production.js","path":"head-dlb/static-1.368/bundle.production.js","ids":{}},{"name":"reporting-dlb/bundle.production.js","path":"reporting-dlb/static-1.25620/bundle.production.js","ids":{}},{"name":"hubspot-dlb/bundle.production.js","path":"hubspot-dlb/static-1.438/bundle.production.js","ids":{"enviro":"LZPL"}},{"name":"apollo-dlb/bundle.production.js","path":"apollo-dlb/static-2.80/bundle.production.js","ids":{}}];
 	__webpack_require__.dlbpr = function(dlbId, id) {
 	  var dlb = dlbs[dlbId];
 	  if (!dlb.r) {
 	    dlb.r = window['__webpack_require_' + dlb.name + '__'];
 	    if (!dlb.r) {
 	      throw new Error('dlb ' + dlb.name + ' not loaded');
 	    }
 	    // the first time a dlb module is required, we link it
 	    dlb.r.linkDlb(__webpack_require__, dlb.ids);
 	  }
 	  return dlb.r(id);
 	}
 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static.hsappstatic.net/AdsUI/static-1.58205/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "pGBH");
